import React from 'react';
import PropTypes from 'prop-types';

import SearchResult from './SearchResult';
import SearchMessage from './SearchMessage';

const SearchResults = ({ searched, items }) => (
    <div className="search__result">
        {items.length === 0 && searched && (
            <SearchMessage message="Er zijn helaas geen resultaten voor je zoekopdracht." />
        )}
        {items.length === 0 && !searched && (
            <SearchMessage message="Geef een zoekterm in en klik op zoeken." />
        )}

        <div className="teaser-list">
            {items.map(item => <SearchResult item={item} />)}
        </div>
    </div>
);

SearchResults.propTypes = {
    searched: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
};

export default SearchResults;
